import React, { useState, useEffect } from "react";
import _ from "lodash";


const colors = [
  "rgb(238, 115, 167)",
  "rgb(255, 140, 0)",
  "rgb(255, 238, 51)",
  "rgb(14, 232, 167)", 
  "rgb(106, 193, 214)",
  "rgb(186, 188, 194)",
  "rgb(255, 60, 0)",
  "rgb(85, 83, 211)",
  "rgb(49, 143, 67)",
  "rgb(203, 83, 211)",
  "rgb(255, 145, 235)",
  "rgb(211, 83, 117)",
  "rgb(211, 83, 93)", 
  "rgb(255, 159, 197)"
];


export default function App() {
  let puzzle = [];

  const [gameState, setGameState] = useState([]);

  const numColors = 10;
  const tubeHeight = 4;
  const numEmptyTube = 2;

  const [selectedNode, setSelectedNode] = useState(null);
  const [highNode, setHighNode] = useState(null);


  const findColNodes = col => {
    return _.chain(gameState)
      .filter(node => node.col === col)
      .sortBy("row")
      .value();
  };

  const [scaleSize, setScaleSize] = useState(10 / (numColors + numEmptyTube));

    const maxWidth = 630; // Ancho máximo del contenedor



  const hashPosition = ({ row, col }) => `${row}.${col}`;         

  const onClickTube = col => () => {
    const colNodes = findColNodes(col);

    const firstNode = colNodes[0];
    const node = gameState[selectedNode];
    if (node) 
    {
      if (node.col === col) {
        setHighNode(null);
      } else if (
        !firstNode ||
        (colNodes.length < tubeHeight &&
          firstNode.colorIndex === node.colorIndex)
      ) {

        const newState = { ...gameState };
        newState[selectedNode] = {
          ...node,
          col,
          row: firstNode ? firstNode.row - 1 : tubeHeight - 1
        };

        const newStateTubes = _.keyBy(newState, hashPosition);

        setGameState(newStateTubes);
        setHighNode(hashPosition(newState[selectedNode]));
        setTimeout(() => {
          setHighNode(null);
        }, 200);

        const isSolved = checkIfGameIsSolved(newStateTubes);
        if (isSolved) 
        {
          console.log("El juego está resuelto");
          const event = new CustomEvent('mi_wingame');
          window.dispatchEvent(event);
        }
      } else {
        setHighNode(null);
      }
      setSelectedNode(null);
    } 
    else if (firstNode) 
    {
      setSelectedNode(hashPosition(firstNode));
      setHighNode(hashPosition(firstNode));
    } 
    else 
    {
      setSelectedNode(null);
      setHighNode(null);
    }
  };

  const reversefour = (arr) => {
    let result = [];

    for (let i = 0; i < arr.length; i += 4) 
    {
        let group = arr.slice(i, i + 4);

        result = result.concat(group.reverse());
    }

    return result;
  }


  const init = () => {
    puzzle = reversefour(window.puzzle);

    setSelectedNode(null);
    setHighNode(null);

    const positions = _.chain(numColors)
      .range()
      .map(col => {
        return _.range(tubeHeight).map(row => ({ row, col }));
      })
      .flatten()
      .value();

    let state = _.chain(positions)
      .map((position, index) => {
        return {
          ...position,
          colorIndex: puzzle[index],
          key: index
        };
      })
      .keyBy(hashPosition)
      .value();

    setGameState(state);
  };

  useEffect(init, []);

  useEffect(() => {

    const handleResize = () => {
      const windowWidth = document.documentElement.clientWidth - 50;
      const scaleValue = windowWidth < maxWidth ? windowWidth / maxWidth : 1;
      setScaleSize(scaleSize*scaleValue);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const checkIfGameIsSolved = (newstate) => {
    const findColNodesState = (col) => {
      return _.chain(newstate)
      .filter(node => node.col === col)
      .sortBy("row")
      .value();
    };

    const tubes = _.range(numColors + numEmptyTube).map(col => findColNodesState(col));

    for (const tube of tubes) 
    {
      if (tube.length === 0) continue;
      if (tube.length !== tubeHeight) return false;

      const colorIndex = tube[0].colorIndex;

      for (const node of tube) 
      {
        if (node.colorIndex !== colorIndex) 
        {
          return false; 
        }
      }
    }

    return true;
  };



  const checkIfTubeIsSolved = col => {
    const nodesInTube = findColNodes(col);

    if (nodesInTube.length !== tubeHeight)
      return false;

    const colorIndex = nodesInTube[0].colorIndex;

    return nodesInTube.every(node => node.colorIndex === colorIndex);
  };


  const tubeTopStyle = col => {
    const isTubeSolved = checkIfTubeIsSolved(col);
    const width = Math.ceil(scaleSize * 72)+10;

    return {
      borderRadius: scaleSize * 15,
      width: width,
      height: scaleSize * 7,
      left: -(width-Math.ceil(scaleSize * 72))/2-1,
      top: scaleSize * -5,
      position: "absolute",
      transition: "all ease 0.2s",
      border: `1px #333 solid`,
      background: isTubeSolved ? "#f3f5d5" : "#efefef"
    }
  };



  const tubeStyle = col => {
    const isTubeSolved = checkIfTubeIsSolved(col);

    return {
      borderRadius: "0px 0px 60px 60px",
      width: Math.ceil(scaleSize * 72),
      height: scaleSize * tubeHeight*2 * 35,
      position: "absolute",
      left: scaleSize * ((col>5?col-6:col) * 126),
      top: (col>5)?scaleSize * tubeHeight * 60+scaleSize*160:0,
      borderTop: "none",
      background: isTubeSolved ? "#f3f5d5" : "#efefef",
      transition: "all ease 0.2s",
      cursor: "pointer",
      border: `1px #333 solid`,
      boxShadow: "inset 0 -2px 4px rgba(0, 0, 0, 0.2)"
    };
  }



const circleStyle = (row, col, colorIndex, isSelected) => ({
  borderRadius: scaleSize * 50,
  background: colors[colorIndex],
  width: Math.ceil(scaleSize * 56),
  height: Math.ceil(scaleSize * 56),
  position: 'absolute',
  left: scaleSize * (col>5?col-6:col) * 126 + (scaleSize * 72 - (scaleSize * 56))/2,
  top:
    (isSelected
      ? -scaleSize * 72 + (col>5?(scaleSize * tubeHeight * 60+scaleSize*160):0)
      : scaleSize * 11 + (row * scaleSize * 56 + row*scaleSize*11) + (col>5?(scaleSize * tubeHeight * 60+scaleSize*160):0)),
  transition: 'all ease 0.2s',
  pointerEvents: 'none',
  boxShadow: "0 2px 2px rgba(255, 255, 255, 0.8), inset 0 -2px 4px rgba(0, 0, 0, 0.1)"
});



 return (
    <>
      <div
        className="App"
        style={{
          paddingTop: "50px",
          paddingBottom: "50px",
          margin: 0,
          backgroundSize: "cover",
          pointerEvent: "none",
          userSelect: "none",
          boxSizing: "border-box"
        }}
        tabIndex="0"
      >
       
        <div className="game-container"
          style={{
            transformOrigin: "top left",
            width: scaleSize * 72 + scaleSize * (((numColors + numEmptyTube)/2-1) * 126),
            height: scaleSize * tubeHeight*2 * 72+scaleSize*160,
            position: "relative",
            margin: "auto",
          }}
        >
          {_.range(numColors + numEmptyTube).map(col => (
            <div
              key={`tube-${col}`}
              onClick={onClickTube(col)}
              style={tubeStyle(col)}
            >
              <div
                style={tubeTopStyle()}
              />
            </div>
          ))}

          {_.map(gameState, ({ row, col, colorIndex, key, locked }) => (
            <div
              key={key}
              style={circleStyle(row, col, colorIndex, (hashPosition({ row, col }) === highNode))}
            />
          ))}

        </div>
      </div>

      <div className="buttons">       
            <button onClick={init} className="btn btn-default reset">Reiniciar</button>
        </div>
    </>
  );
}
